import { Text } from "@clipboard-health/ui-components";
import { Box, CardContent, List, ListItem, ListItemText, Stack } from "@mui/material";

import { WorkplaceReferralCard } from "../WorkplaceReferralCard/WorkplaceReferralCard";

export function ReferralExplanationCard() {
  const HOW_IT_WORKS_STEPS = [
    "Invite workplaces to join Clipboard Health by sharing your personalized referral link",
    "Once the workplace has their first shift verified on Clipboard, your referral is complete",
    "You’ll receive a deposit in your account once their first shift is complete",
  ];

  return (
    <WorkplaceReferralCard>
      <CardContent
        sx={(theme) => ({
          backgroundColor: theme.palette.common.white,
        })}
      >
        <Stack spacing={1}>
          <Text bold variant="h4">
            How It Works
          </Text>
          <List>
            {HOW_IT_WORKS_STEPS.map((description, index) => (
              <ListItem key={description} sx={{ paddingY: 3 }}>
                <ListItemText
                  primary={
                    <Stack direction="row" spacing={4}>
                      <Box
                        sx={(theme) => ({
                          width: 20,
                          height: 20,
                          borderRadius: "50%",
                          backgroundColor: theme.palette.primary.main,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          flexShrink: 0,
                        })}
                      >
                        <Text
                          variant="body2"
                          sx={(theme) => ({ color: theme.palette.common.white })}
                        >
                          {index + 1}
                        </Text>
                      </Box>
                      <Text>{description}</Text>
                    </Stack>
                  }
                />
              </ListItem>
            ))}
          </List>
        </Stack>
      </CardContent>
    </WorkplaceReferralCard>
  );
}
